// extracted by mini-css-extract-plugin
export default {"segmentItem":"segmentItem__hcG30A","icon":"icon__Q67O5E","transcriptions":"transcriptions__rDOsfR","deleteIcon":"deleteIcon__FlVY8i"};